import { Tilbakemelding } from '../..';

export const initialTilbakemeldingState: TilbakemeldingState = {
	tilbakemelding: {
		tilbakemeldingspunkter: [],
		vedlegg: [],
	},
};

export interface TilbakemeldingState {
	tilbakemelding: Tilbakemelding;
}

type SetTilbakemeldingerAction = {
	type: 'SETT_TILBAKEMELDINGER_ACTION';
	payload: Tilbakemelding;
};

export type TilbakemeldingActions = SetTilbakemeldingerAction;

export function reducer(
	state: TilbakemeldingState,
	action: TilbakemeldingActions
): TilbakemeldingState {
	switch (action.type) {
		case 'SETT_TILBAKEMELDINGER_ACTION':
			return { ...state, tilbakemelding: action.payload };
		default:
			return state;
	}
}
